'use strict';

var _defineProperty = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var bufferModule = require('buffer');

var _require = require('./primordials'),
    kResistStopPropagation = _require.kResistStopPropagation,
    SymbolDispose = _require.SymbolDispose;

var AbortSignal = globalThis.AbortSignal || require('abort-controller').AbortSignal;

var AbortController = globalThis.AbortController || require('abort-controller').AbortController;

var AsyncFunction = Object.getPrototypeOf( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}))).constructor;
var Blob = globalThis.Blob || bufferModule.Blob;
/* eslint-disable indent */

var isBlob = typeof Blob !== 'undefined' ? function isBlob(b) {
  // eslint-disable-next-line indent
  return b instanceof Blob;
} : function isBlob(b) {
  return false;
};
/* eslint-enable indent */

var validateAbortSignal = function validateAbortSignal(signal, name) {
  if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
  }
};

var validateFunction = function validateFunction(value, name) {
  if (typeof value !== 'function') throw new ERR_INVALID_ARG_TYPE(name, 'Function', value);
}; // This is a simplified version of AggregateError


var AggregateError = /*#__PURE__*/function (_Error) {
  _inherits(AggregateError, _Error);

  var _super = _createSuper(AggregateError);

  function AggregateError(errors) {
    var _this;

    _classCallCheck(this, AggregateError);

    if (!Array.isArray(errors)) {
      throw new TypeError("Expected input to be an Array, got ".concat(typeof errors));
    }

    var message = '';

    for (var i = 0; i < errors.length; i++) {
      message += "    ".concat(errors[i].stack, "\n");
    }

    _this = _super.call(this, message);
    _this.name = 'AggregateError';
    _this.errors = errors;
    return _this;
  }

  return AggregateError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

module.exports = {
  AggregateError: AggregateError,
  kEmptyObject: Object.freeze({}),
  once: function once(callback) {
    var called = false;
    return function () {
      if (called) {
        return;
      }

      called = true;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      callback.apply(this, args);
    };
  },
  createDeferredPromise: function createDeferredPromise() {
    var resolve;
    var reject; // eslint-disable-next-line promise/param-names

    var promise = new Promise(function (res, rej) {
      resolve = res;
      reject = rej;
    });
    return {
      promise: promise,
      resolve: resolve,
      reject: reject
    };
  },
  promisify: function promisify(fn) {
    return new Promise(function (resolve, reject) {
      fn(function (err) {
        if (err) {
          return reject(err);
        }

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return resolve.apply(void 0, args);
      });
    });
  },
  debuglog: function debuglog() {
    return function () {};
  },
  format: function format(_format) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
    return _format.replace(/%([sdifj])/g, function () {
      for (var _len4 = arguments.length, _ref2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        _ref2[_key4] = arguments[_key4];
      }

      var _unused = _ref2[0],
          type = _ref2[1];
      var replacement = args.shift();

      if (type === 'f') {
        return replacement.toFixed(6);
      } else if (type === 'j') {
        return JSON.stringify(replacement);
      } else if (type === 's' && typeof replacement === 'object') {
        var ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
        return "".concat(ctor, " {}").trim();
      } else {
        return replacement.toString();
      }
    });
  },
  inspect: function inspect(value) {
    // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
    switch (typeof value) {
      case 'string':
        if (value.includes("'")) {
          if (!value.includes('"')) {
            return "\"".concat(value, "\"");
          } else if (!value.includes('`') && !value.includes('${')) {
            return "`".concat(value, "`");
          }
        }

        return "'".concat(value, "'");

      case 'number':
        if (isNaN(value)) {
          return 'NaN';
        } else if (Object.is(value, -0)) {
          return String(value);
        }

        return value;

      case 'bigint':
        return "".concat(String(value), "n");

      case 'boolean':
      case 'undefined':
        return String(value);

      case 'object':
        return '{}';
    }
  },
  types: {
    isAsyncFunction: function isAsyncFunction(fn) {
      return fn instanceof AsyncFunction;
    },
    isArrayBufferView: function isArrayBufferView(arr) {
      return ArrayBuffer.isView(arr);
    }
  },
  isBlob: isBlob,
  deprecate: function deprecate(fn, message) {
    return fn;
  },
  addAbortListener: require('events').addAbortListener || function addAbortListener(signal, listener) {
    if (signal === undefined) {
      throw new ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
    }

    validateAbortSignal(signal, 'signal');
    validateFunction(listener, 'listener');
    var removeEventListener;

    if (signal.aborted) {
      queueMicrotask(function () {
        return listener();
      });
    } else {
      signal.addEventListener('abort', listener, _defineProperty({
        __proto__: null,
        once: true
      }, kResistStopPropagation, true));

      removeEventListener = function removeEventListener() {
        signal.removeEventListener('abort', listener);
      };
    }

    return _defineProperty({
      __proto__: null
    }, SymbolDispose, function () {
      var _removeEventListener;

      (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
    });
  },
  AbortSignalAny: AbortSignal.any || function AbortSignalAny(signals) {
    // Fast path if there is only one signal.
    if (signals.length === 1) {
      return signals[0];
    }

    var ac = new AbortController();

    var abort = function abort() {
      return ac.abort();
    };

    signals.forEach(function (signal) {
      validateAbortSignal(signal, 'signals');
      signal.addEventListener('abort', abort, {
        once: true
      });
    });
    ac.signal.addEventListener('abort', function () {
      signals.forEach(function (signal) {
        return signal.removeEventListener('abort', abort);
      });
    }, {
      once: true
    });
    return ac.signal;
  }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');